import './OnboardingPages.scss';

import React, {useEffect, useState} from 'react';
import HandicaddieLogo from "../../../icons/HandicaddieLogo";
import {Formik} from "formik";
import {useLocation, useNavigate} from "react-router-dom";
import * as yup from "yup";
import {SessionService} from "../../../services/api/SessionService";
import {CredentialsService} from "../../../services/api/CredientialsService";
import {LOGIN} from "../../../services/PageUtils";
import ErrorText from "../../../components/ErrorText";
import FormContainer from "../components/FormContainer";
import ErrorBox from "../components/ErrorBox";
import Button from "../../../components/Button";

interface Props {

}

const Register = ({}: Props) => {

    const navigate = useNavigate();
    const location: any = useLocation();

    const {confirmEmail} = CredentialsService()
    const {createSession} = SessionService()

    const [errMsg, setErrMsg] = useState<string>();
    const [loading, setLoading] = useState(false);

    const schema = yup.object().shape({
        code: yup.string().required("Code is required"),
    });

    useEffect(() => {
        setLoading(false);
    }, []);

    const submitForm = async (values: any) => {
        setLoading(true);
        setErrMsg(undefined);

        try {
            let confirmEmailResp = await confirmEmail({
                email: location.state.email,
                password: location.state.password,
            }, values.code)

            if (confirmEmailResp.error) {
                if (confirmEmailResp.error.apiError?.code === 'E1000') {
                    navigate(LOGIN);
                    return;
                }

                setErrMsg(confirmEmailResp.error.message);
                return;
            }

            let sessionResp = await createSession({
                email: location.state.email,
                password: location.state.password,
            })

            if (sessionResp.error) {
                navigate(LOGIN);
                return;
            }
        } catch (e) {
            setErrMsg("Unknown problem occurred. Try refreshing and try again.")
        } finally {
            setLoading(false);
        }
    };

    return (
        <FormContainer>
            <div className={"header_logoContainer"}>
                <HandicaddieLogo size={'lg'}/>
            </div>

            <span className={"heading"} style={{ alignSelf: 'flex-start' }}>Email Confirmation</span>

            <Formik
                validationSchema={schema}
                onSubmit={submitForm}
                initialValues={{
                    code: "",
                }}
            >
                {({
                      handleSubmit,
                      handleChange,
                      handleBlur,
                      values,
                      touched,
                      isValid,
                      errors,
                  }) => (
                    <form onSubmit={handleSubmit}>
                        <h3 className={"onboarding_labelWithExplanation"}>
                            Code
                        </h3>
                        <span className={"onboarding_explanation"}>
                            We have sent you a code to the email you used to register, please enter that code here.
                        </span>
                        <div style={{marginTop: '0.25em'}}>
                            <input
                                required
                                className="onboarding_input"
                                type="text"
                                name="code"
                                placeholder="xxxx"
                                value={values.code}
                                onBlur={handleBlur}
                                onChange={handleChange}
                            />
                            {touched.code &&
                                errors.code && (
                                    <ErrorBox text={errors.code} />
                                )}
                        </div>

                        {errMsg && <ErrorBox text={errMsg}/>}
                        <div style={{ marginTop: '1em' }}>
                            <Button text="CONFIRM EMAIL" type="submit" disabled={loading} />
                        </div>
                    </form>
                )}
            </Formik>
        </FormContainer>
    )
}

export default Register;